<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <h3>Олон улсын үнэ тариф</h3>
          <button class="modal-close-button" @click="$emit('close')">X</button>
        </div>

        <div class="modal-body">
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Хайлт хийх..."
            class="search-input"
          />

          <div class="table-container" v-if="filteredData.length">
            <table>
              <thead>
                <tr>
                  <th v-for="(key, i) in Object.keys(data[0])" :key="i">{{ key }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in filteredData" :key="index">
                  <td v-for="(value, key) in item" :key="key">{{ value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>Өгөгдөл байхгүй</div>
        </div>
      </div>
    </div>
  </div>
</template>



<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.modal-container {
  background: white;
  padding: 20px;
  width: 80%;
  max-width: 800px;
  max-height: 80vh;
  overflow: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.modal-body {
  margin-top: 20px;
}

.search-input {
  margin-bottom: 10px;
  padding: 8px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.table-container {
  max-height: 60vh;
  overflow: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-weight: normal; 
}

th {
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>


<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchQuery: ""
    };
  },
  computed: {
    filteredData() {
      if (!this.searchQuery) return this.data;
      const lowerQuery = this.searchQuery.toLowerCase();
      return this.data.filter(item =>
        Object.values(item).some(
          val => String(val).toLowerCase().includes(lowerQuery)
        )
      );
    }
  }
};
</script>
